const mainSearchForm = {
  flights: "Penerbangan", // translated 
  tours: "Lawatan", // translated 
  hotel: "Hotel", // translated 
  hotels: "Hotel", // translated 
  services: "Perkhidmatan", // translated 
  search: "CARIAN", // translated 
  destination: "Destinasi", // translated 
  includedServices: "Perkhidmatan yang Termasuk", // translated 
  packageDuration: "Tempoh Pakej", // translated 
  checkInOut: "Daftar masuk/keluar", // translated 
  guests: "Tetamu", // translated 
  adults: "Dewasa", // translated 
  children: "Kanak-kanak", // translated 
  child: "Kanak-kanak", // translated 
  age: "Umur", // translated 
  yearsOld: "Tahun", // translated 
  rooms: "Bilik-bilik", // translated 
  close: "Tutup", // translated 
  searchType: "Jenis Carian", // translated 
  accommodation: "Penginapan", // translated 
  transfers: "Pemindahan", // translated 
  toursExperiences: "Lawatan/Pengalaman", // translated 
  nights: "Malam-malam", // translated 
  days: "Hari", // translated 
  packageType: "Jenis Pakej", // translated 
  tourType: "Jenis Lawatan", // translated 
  packages: "Pakej", // translated 
  cars: "Kereta", // translated 
  cruises: "Pelayaran", // translated 
  infantsInSeat: "Bayi di tempat duduk", // translated 
  infantsOnLap: "Bayi di atas riba", // translated 
  airport: "Lapangan Terbang", // translated 
  passengers: "Penumpang", // translated 
  departureReturn: "Tarikh berlepas dan pulang", // translated 
  origin: "Asal", // translated 
  roundTrip: "Perjalanan Pergi Balik", // translated 
  isRoundTrip: "Adakah Perjalanan Pergi Balik", // translated 
  dream_packages: "Pakej Impian", // translated 
  partying: "Berpesta", // translated 
  thingsToDo: "Perkara Yang Perlu Dilakukan", // translated 
};








export default mainSearchForm;
